import { useState, useEffect, useMemo } from "react"
import { useStores } from "stores/root-store"
import { storageName } from "shared/constants/storage-constant"

import UploadDialog from "components/common/upload/upload-dialog"
import template from "assets/templates/eStore Logistics ASN Template.zip"
import { columnsUpload, filterData, columns, hiddenColumns, columnsUploadFunctionsMap } from "./constants"
import { rootStore } from "stores/root-store"
import InboundDeliveryForm from "components/inbound-delivery/dialog/inbound-delivery-form"
import { observer } from "mobx-react-lite"
import CommonPage from "components/common/common-page"
import { useNavigate, useSearchParams } from "react-router-dom"
import { getModuleName } from "utils/app-helper"
import * as StorageHelper from "utils/storage-helper"
import { parsePresetFilters } from "utils/preset-filters"

// Multi-select filters a link into this page (e.g. a home dashboard tile) can
// pre-set via the query string; each accepts a comma-separated list of values.
const PRESET_MULTI_FILTERS = ["warehouse", "receipt_type", "receipt_status"]

const InboundDelivery = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [openUpload, setOpenUpload] = useState(false)

  const { InboundDeliveryStore } = useStores()

  const moduleName = getModuleName(storageName.inboundFilter)

  const presetFilters = useMemo(() => parsePresetFilters(searchParams, PRESET_MULTI_FILTERS), [searchParams])

  useEffect(() => {
    rootStore.setOpenForm(false)
    rootStore.setScreenTitle("Inbound Delivery Search")
    InboundDeliveryStore.resetData()

    const importingModule = StorageHelper.getStorage(storageName.importingModule)
    if (importingModule === moduleName) setOpenUpload(true)

    return () => rootStore.setScreenTitle("")
  }, [])

  const refreshDataIfNeeded = () => {
    if (InboundDeliveryStore.searchText) InboundDeliveryStore.loadData()
  }

  const handleClickOpen = () => {
    rootStore.setScreenTitle("")
    rootStore.setOpenForm(true)
  }

  const handleClickOpenUpload = () => {
    setOpenUpload(true)
  }

  const handleUploadClose = () => {
    setOpenUpload(false)
    refreshDataIfNeeded()
  }

  const handleClose = () => {
    InboundDeliveryStore.setSelectedId("")
    rootStore.setScreenTitle("Inbound Delivery Search")
    rootStore.setOpenForm(false)
  }

  const handleSave = () => {
    handleClose()
    refreshDataIfNeeded()
  }

  const handleRowClicked = params => {
    navigate(`/inbound-delivery/${encodeURIComponent(params.row["RECEIPT_ID"])}/${encodeURIComponent(params.row["ID"])}`)
  }

  if (rootStore.openForm) return <InboundDeliveryForm onSave={handleSave} onClose={handleClose} />

  return (
    <>
      <CommonPage
        DataStore={InboundDeliveryStore}
        filterData={filterData}
        presetFilters={presetFilters}
        searchPlaceholder={"Search by Receipt ID, Tracking Number, ERP Number, or Supplier."}
        filterStorageName={storageName.inboundFilter}
        allowArchivalSearch={true}
        columns={columns}
        hiddenColumns={hiddenColumns}
        gridStorageName={storageName.inboundColumn}
        searchRequiredWarningMsg="Search for a specific inbound delivery and select a filter to narrow down your search"
        noDataMsg="Your search returned no results. Please contact ops@estorelogistics.com.au if you believe this error is incorrect."
        exportFileName="Express_InboundDelivery"
        handleAddClicked={handleClickOpen}
        handleUploadClicked={handleClickOpenUpload}
        handleRowClicked={handleRowClicked}
      />

      <UploadDialog
        title={"Inbound Delivery"}
        moduleName={moduleName}
        startFrom={6}
        columns={columnsUpload}
        columnsUploadFunctionsMap={columnsUploadFunctionsMap}
        idColumn={"ID"}
        DataStore={InboundDeliveryStore}
        downloadLink={template}
        open={openUpload}
        onClose={handleUploadClose}
      />
    </>
  )
}

export default observer(InboundDelivery)
